import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import { InView } from "react-intersection-observer";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { useSlider } from "@app/hooks/use-slider/useSlider";
import { AnimationState } from "@app/hooks/use-slider/enums";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText } from "../../models";
import { Slide } from "./types";
import { Slider } from "./components/slider/Slider";
import { DELAY_MS } from "./components/slider/constants";

type Props = {
  title: RichText;
  slides: Slide[];
};

export const SideImageSlides: FC<Props> = ({ title, slides }) => {
  const {
    activeSlide,
    animationState,
    onChangeSlide,
    onStartPlay,
    onPause,
    onNextSlideSwitch,
    onPreviousSlideSwitch,
  } = useSlider({
    numberOfSlides: slides.length,
    durationInMS: DELAY_MS,
  });

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <InView
        threshold={0.6}
        onChange={(inView) => {
          if (inView && animationState === AnimationState.STOPED) {
            onStartPlay();
          }
        }}
      >
        <div
          className={classNames(
            "mt-20 space-y-10 px-5",
            "lg:mt-25 lg:space-y-11 lg:px-16",
            "xl:mx-auto xl:mt-40 xl:max-w-container-wide xl:space-y-40 xl:px-24",
          )}
        >
          <BlockHeader
            richText={title}
            className={classNames(
              "text-center text-large text-primary-content",
              "lg:text-xx-large",
            )}
          />
          <Slider
            data={slides}
            {...{
              activeSlide,
              animationState,
              onChangeSlide,
              onNextSlideSwitch,
              onPreviousSlideSwitch,
              onPause,
              onStartPlay,
            }}
          />
        </div>
      </InView>
    </Fade>
  );
};
